import { tap, distinctUntilChanged, pipe } from 'rxjs';

import { renderTemplate } from './view.js';

export function findParent(element, match) {
    element = element.parentElement;
    for (;;) {
        if (!element) {
            return null;
        }
        if (match(element)) {
            return element;
        }
        element = element.parentElement;
    }
}

export function syncInto(element, property) {
    return pipe(
        distinctUntilChanged(),
        tap((value) => (element[property] = value))
    );
}

export function showErrorBanner(container, message) {
    let existing = container.querySelector('.error-banner');
    if (existing) {
        existing.remove();
    }
    let banner = renderTemplate('error-banner');
    banner.querySelector('.error-message').textContent = message;
    banner.querySelector('.error-close').addEventListener('click', () => banner.remove(), false);
    container.prepend(banner);
}
